"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthRegistry = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const bytes_1 = require("@ethersproject/bytes");
const AbstractKeyRegistry_1 = require("./AbstractKeyRegistry");
const Registry_1 = require("./Registry");
class EthRegistry extends Registry_1.Registry {
    static forEthAddress(ethAddress, wallet, connection, cluster = "mainnet-beta") {
        const trimmedEthAddress = ethAddress.substring(2); // without 0x
        return new EthRegistry(wallet, connection, Buffer.from(trimmedEthAddress, "hex"), AbstractKeyRegistry_1.ETH_KEY_REGISTRY_SEED_PREFIX, cluster);
    }
    register(did) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = this.didToAccount(did);
            return this.program.methods
                .registerDidForEthAddress(Array.from(this.address), account.bump)
                .accounts({
                registry: this.registryAddress,
                authority: this.wallet.publicKey,
                did: account.authority,
                didAccount: account.account,
            });
        });
    }
    ethSignMessage(message, signer) {
        return __awaiter(this, void 0, void 0, function* () {
            // We do not use a dynamic nonce here - there is no risk of replay when adding a DID to a registry
            const staticNonce = Buffer.from(new bn_js_1.default(0).toArray("le", 8));
            const messageToSign = Buffer.concat([message, staticNonce]);
            const signatureFull = yield signer.signMessage(messageToSign);
            const signatureBytes = (0, bytes_1.arrayify)(signatureFull);
            const signature = Array.from(signatureBytes.slice(0, -1));
            // // map [0x1b, 0x1c] to [0, 1]
            // https://docs.ethers.io/v4/api-utils.html#signatures
            const recoveryId = signatureBytes.at(-1) - 27;
            return {
                signature,
                recoveryId,
            };
        });
    }
    registerSigned(did, ethWallet) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = this.didToAccount(did);
            // TODO: Change message to come directly from instruction OR only accept update via cryptid
            // TODO: This allows replay attacks
            const signature = yield this.ethSignMessage(account.authority.toBuffer(), ethWallet);
            console.log({
                registry: this.registryAddress.toBase58(),
                authority: this.wallet.publicKey.toBase58(),
                did: account.authority.toBase58(),
                didAccount: account.account.toBase58(),
                signature,
            });
            return this.program.methods
                .registerDidSignedByEthAddress(Array.from(this.address), signature, account.bump)
                .accounts({
                registry: this.registryAddress,
                did: account.authority,
                didAccount: account.account,
            });
        });
    }
}
exports.EthRegistry = EthRegistry;
//# sourceMappingURL=EthRegistry.js.map